var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOPequenoPrincipe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 156,
    viewBox: "0 0 25 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6389 0.998029L0 1.04639L0.34668 156L24.9856 155.952L24.6389 0.998029Z",
    fill: "#63A69F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4986 74.9727C11.4853 74.9727 10.6853 74.2579 10.6853 73.3526L10.5254 15.6977C10.5254 14.7924 11.3254 14.0776 12.3387 14.0776C13.352 14.0776 14.1519 14.7924 14.1519 15.6977L14.3119 73.3526C14.3119 74.2579 13.5119 74.9727 12.4986 74.9727Z",
    fill: "#CE5E58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOPequenoPrincipe);
export default __webpack_public_path__ + "static/media/o-pequeno-principe.3f9cb23d.svg";
export { ForwardRef as ReactComponent };